import { useCallback, useEffect, useState } from "react";

import { fetchRewardsSummary } from "../api/rewardsSummaryApi";

export default function useRewardsSummary({ enabled = true, accountKey = null } = {}) {
  const [requestVersion, setRequestVersion] = useState(0);
  const [state, setState] = useState(() => ({
    status: enabled ? "loading" : "idle",
    data: null,
    error: null,
  }));

  const refresh = useCallback(() => {
    if (enabled) setRequestVersion((version) => version + 1);
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setState({ status: "idle", data: null, error: null });
      return undefined;
    }

    const controller = new AbortController();
    let active = true;
    setState({ status: "loading", data: null, error: null });

    fetchRewardsSummary({ signal: controller.signal })
      .then((data) => {
        if (!active) return;
        setState({ status: "ready", data, error: null });
      })
      .catch((error) => {
        if (!active || error?.name === "AbortError") return;
        setState({ status: "error", data: null, error });
      });

    return () => {
      active = false;
      controller.abort();
    };
  }, [accountKey, enabled, requestVersion]);

  useEffect(() => {
    if (!enabled || typeof window === "undefined") return undefined;
    window.addEventListener("eternua:rewards-updated", refresh);
    return () => window.removeEventListener("eternua:rewards-updated", refresh);
  }, [enabled, refresh]);

  return {
    ...state,
    refresh,
  };
}
